module.exports = __webpack_public_path__ + "static/media/qr_code_emec.95486a99.png";